<template>
	<div>
		<textarea class="uk-textarea" v-model="params.desc" name="book" placeholder="Задание для самостоятельного чтения"></textarea>
	</div>
</template>

<script>
  export default {
    name: "settings",
    data() {
      return {
        params: {
          desc: "",
	        title: "Чтение книги",
	        code: "book"
        }
      }
    },
    watch: {
      params: {
        handler: function(newValue) {
          this.$emit('params_changed', this.params);
        },
        deep: true
      }
    },
    mounted() {
      this.$emit('params_changed', this.params);
    }
  }
</script>